import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Categoria`

export function buscarPorId(idCategoriaPadre) {
  return http.get(`${API_ENDPOINT}/BuscarPorId/${idCategoriaPadre}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las categorías.',
      tipoError: 'categoria'
    }
  })
}

export function buscarMetadato(idCategoria) {
  return http.get(`${API_ENDPOINT}/BuscarMetadato/${idCategoria}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las características.',
      tipoError: 'categoria'
    }
  })
}

export function buscarAtributos(idCategoria) {
  return http.get(`${API_ENDPOINT}/BuscarAtributos/${idCategoria}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los atributos.',
      tipoError: 'categoria'
    }
  })
}
